<div class="course-select-list">
<!--    <div class="create-button"><button [routerLink]='"create"' nbButton status="primary" [disabled]="disableCreate">New Course</button></div>-->
    <div *ngIf="view">
        <app-view [items]="view?.data?.content" [info]="view?.data"></app-view>
        <!-- <div class="course-select-card" *ngFor="let co of view">
            <app-course-card [course]="co"></app-course-card>
        </div> -->
    </div>
</div>

